
























import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import { newsletterWebservice } from '../webservices/newsletter.webservice'

@Component
export default class Newsletter extends Vue {
    private email = ''
    private loading = false
    private added = false

    private async storeEmail() {
        if (this.email && this.email.length >= 10 && !this.added) {
            this.loading = true
            const result = await newsletterWebservice.storeNewsletter(this.email)
            this.loading = false

            if (result.status === 200) {
                this.added = true
            }
        }
    }

    private get buttonText() {
        return this.added ? 'Yay, willkommen' : 'Anmelden'
    }
}
